let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aRRwi")).then(() => parcelRequire('9u9vi'));